import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { getParamByName } from '../common/Utils';

const history = window.History;
const title = document.getElementsByTagName('title')[0].innerText;

export default function useRouter(keys: string[]) {
    const [params, paramsSet] = useState<{ [key: string]: string }>();

    useEffect(() => {
        history.Adapter.bind(window, 'statechange', () => {
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                const val = getParamByName(key) || '';

                paramsSet((current) => {
                    return {
                        ...current,
                        [key]: val,
                    };
                });
            }
        });

        history.Adapter.trigger(window, 'statechange');
    }, []);

    const getValue = (key: string, who: string = '') => {
        return params ? params[key] : '';
    };

    const changeParam = (_newParamObj: { [key: string]: string } = {}, who: string = '') => {
        let oldParamObj: { [key: string]: string } = {};
        document.location.search
            .substring(1)
            .split('&')
            .map((it) => {
                const [key, val] = it.split('=');
                if (!val) return '';
                oldParamObj[key] = decodeURIComponent(val);
            });

        const paramObj = queryString.stringify(Object.assign(oldParamObj, _newParamObj));

        history.pushState(null, title, '?' + paramObj);
    };

    return { params, getValue, changeParam };
}
